import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'tongueLocation' })
export class TongueLocationPipe implements PipeTransform {
  transform(value: number, lang: 'en' | 'cn' = 'en'): string {
    const enMap: Record<number, string> = {
      1: 'Center',
      2: 'Root',
      3: 'Front',
      4: 'Tip',
      5: 'Left',
      6: 'Right'
    };

    const cnMap: Record<number, string> = {
      1: '舌中',
      2: '舌根',
      3: '舌前',
      4: '舌尖',
      5: '舌左侧',
      6: '舌右侧'
    };

    const map = lang === 'cn' ? cnMap : enMap;
    return map[value] || 'Unknown';
  }
}
